(function() {
'use strict';

angular
    .module('dashboard')
    .controller('MemberDetails', MemberDetails);

function MemberDetails($rootScope, dashboardNotificationService) {
    const md = this;
    md.user = $rootScope.user;

    //Notifications
    md.notificationClicked = notification => dashboardNotificationService.notificationClicked(notification);
    md.formatNotification = notification => dashboardNotificationService.formatNotification(notification);

    dashboardNotificationService.getNotifications().then(data => md.alerts = data);
}
})();
